import { render, staticRenderFns } from "./RatesListAdmin.vue?vue&type=template&id=63f1ff18&"
import script from "./RatesListAdmin.vue?vue&type=script&lang=js&"
export * from "./RatesListAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports